/* eslint-disable no-restricted-syntax -- destructive CTA colour, matches ConfirmationModal */
/**
 * Confirm-delete body for a comment card (#2244). Rendered inline
 * (no `<Modal>`) so the transcript stays visible while the user
 * confirms.
 */

import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';

export interface CommentCardConfirmDeleteProps {
  id: string;
  onCancel: () => void;
  onConfirm: () => Promise<void> | void;
}

export function CommentCardConfirmDelete({
  id,
  onCancel,
  onConfirm
}: CommentCardConfirmDeleteProps) {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();
  const titleId = `${id}-confirm-title`;

  return (
    <div className="mt-1.5" role="alertdialog" aria-labelledby={titleId}>
      <p
        id={titleId}
        className="text-xs m-0"
        style={{ color: getColour('normalText') }}
      >
        {t('delete-this-comment-question')}
      </p>
      <div className="mt-2 flex items-center justify-end gap-1">
        <button
          type="button"
          onClick={onCancel}
          aria-label={t('cancel')}
          className="inline-flex items-center gap-1 h-7 px-2 rounded-2xl text-[11px] font-medium hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          style={{
            color: getColour('normalText'),
            border: `1px solid ${getColour('border')}`,
            backgroundColor: 'transparent'
          }}
        >
          {t('cancel')}
        </button>
        <button
          type="button"
          onClick={() => onConfirm()}
          aria-label={t('delete')}
          className="inline-flex items-center gap-1 h-7 px-2 rounded-2xl text-[11px] font-semibold hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          style={{
            color: '#fff',
            backgroundColor: 'rgb(220,38,38)'
          }}
        >
          <Trash2 size={12} aria-hidden="true" />
          {t('delete')}
        </button>
      </div>
    </div>
  );
}
